import {z} from 'zod'

export type ShopFormData = {
  lab_id: Id
}

export const ShopFormSchema = z.object({
  lab_id: z.string().or(z.number()),
})

export const SelectType = {
  List: 'list',
  Map: 'map',
} as const

export type SelectTypeValue = (typeof SelectType)[keyof typeof SelectType]
